// Full-document render of the stearns OffersPage: PageSkeleton (the React
// document shell) wrapping the existing offers-page body island. The legacy
// template rendered the body inside <main> with the site header/footer intact;
// the "offers-page" body_class and CollectionPage-typed JSON-LD are carried in
// page_chrome.
import React from "react";

import { templates } from "@reactivated";

import { OffersPageBody } from "../components/OffersPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.OffersPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <OffersPageBody page={props.page} />
    </PageSkeleton>
);
